import { render } from "./ModalPreviewOption.vue?vue&type=template&id=066141cf&scoped=true"
import script from "./ModalPreviewOption.vue?vue&type=script&lang=js"
export * from "./ModalPreviewOption.vue?vue&type=script&lang=js"

import "./ModalPreviewOption.vue?vue&type=style&index=0&id=066141cf&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-066141cf"]])

export default __exports__